export default __webpack_public_path__ + "static/media/upload-file-border-gray.3d6f54ea.svg";